// extracted by mini-css-extract-plugin
export default {"nav":"IconNavigation_nav__5j9NZ","nav_top_button":"IconNavigation_nav_top_button__7Yj1L"};